import React, { useState, useEffect } from 'react';
import { CheckCircle } from 'lucide-react';

interface VSLVideoPlayerProps {
  leadId: string;
  onVideoComplete: () => void;
}

const VSLVideoPlayer: React.FC<VSLVideoPlayerProps> = ({ leadId, onVideoComplete }) => {
  const [hasWatched, setHasWatched] = useState(false);

  // Mark video as watched after 10 seconds (simulating video completion)
  // Note: We track this client-side only for security reasons
  // The database doesn't need to be updated as this is just for UI state
  useEffect(() => {
    const timer = setTimeout(() => {
      setHasWatched(true);
      onVideoComplete();
    }, 10000);

    return () => clearTimeout(timer);
  }, [leadId, onVideoComplete]);

  return (
    <div className="w-full max-w-4xl mx-auto">
      <div className="relative bg-gray-900 rounded-2xl overflow-hidden shadow-2xl aspect-video">
        <iframe 
          className="absolute inset-0 w-full h-full"
          src="https://www.loom.com/embed/eaf0af025ae04610a576f22286f14f0a?autoplay=1"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>

      {hasWatched && (
        <div className="mt-6 flex items-center justify-center gap-2 text-green-400 bg-green-500/10 border border-green-500/20 py-3 px-6 rounded-lg">
          <CheckCircle className="w-5 h-5" />
          <span className="font-medium">Video completed! You can now apply for admission below.</span>
        </div>
      )}
    </div>
  );
};

export default VSLVideoPlayer;